import { IEventsBulkCreated } from '../../../actions/bookingCalendar/event/requestCreateEvent'
import { IEventsStore } from '../../events'

export default function(
  state: IEventsStore,
  action: IEventsBulkCreated,
): IEventsStore {
  return {
    ...state,
    events: [...state.events, ...action.events],
  }
}
